<!-- HomeBanner.vue -->
<template>
  <a :href="allLendersUrl" class="home-banner"
    :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
    <div class="banner-content">
      <div class="banner-info">
        <div class="banner-title">
          {{domainConfig?.siteName}}
        </div>
        <div class="banner-subtitle">
          {{ domainConfig?.['meta']?.title }}
        </div>
      </div>
      <div class="banner-users">
        <div class="user-avatars">
          <div class="avatar-wrapper">
            <div class="avatar">
              <img src="@/assets/avatar-1.png" alt="Avatar" />
            </div>
            <div class="avatar">
              <img src="@/assets/avatar-2.png" alt="Avatar" />
            </div>
            <div class="avatar">
              <img src="@/assets/avatar-3.png" alt="Avatar" />
            </div>
            <div class="avatar">
              <img src="@/assets/avatar-4.png" alt="Avatar" />
            </div>
          </div>
        </div>
        <div class="user-count">
          50,000+ users around the world
        </div>
      </div>
    </div>

    <AdComponent v-if="deviceType == 'mobile'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_1" ref="ads-home-1"
      class="ad-width-100 m_padding" :ads="adsensConfig?.home_1" :showDebug="showDebug" />

    <div class="banner-image">
      <img src="@/assets/banner-m.png" v-if="deviceType === 'mobile'" alt="Banner" />
      <img src="@/assets/banner.png" v-else alt="Banner" />
    </div>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'
import AdComponent from '@/pages/components/AdComponent.vue'

export default {
  name: 'HomeBanner',
  components: {
    AdComponent
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'adsensConfig',
      'showDebug',
      'domainConfig'
    ]),
    allLendersUrl () {
      const path = '/all-lenders'
      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，使用完整路径
        return `/${this.$route.params.channel}${path}`
      } else {
        // 如果没有channel参数，直接导航
        return path
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.home-banner {
	padding: 0px rem(60) 0px rem(120);
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	flex-shrink: 0;
	height: rem(520);
	position: relative;
	cursor: pointer;
	text-decoration: none;

	&.detect_deviece_mobile {
		flex-direction: column;
		padding: rem(60) 0;
		height: auto;
		gap: rem(36);
	}

	.banner-content {
		display: flex;
		flex-direction: column;
		gap: rem(60);
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		width: rem(480);
		position: relative;

		.detect_deviece_mobile & {
			width: 100%;
			padding: 0 rem(16);
			gap: rem(40);
		}
	}

	.banner-info {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.detect_deviece_mobile & {
			gap: rem(20);
		}
	}

	.banner-title {
		color: #1a4048;
		text-align: left;
		font-size: rem(64);
		line-height: rem(68);
		font-weight: 900;
		position: relative;
		align-self: stretch;

		.detect_deviece_mobile & {
			font-size: rem(36);
			line-height: rem(40);
		}
	}

	.banner-subtitle {
		color: var(--theme-primary);
		text-align: left;
		font-size: rem(36);
		line-height: rem(40);
		font-weight: 800;
		position: relative;
		align-self: stretch;

		.detect_deviece_mobile & {
			font-size: rem(24);
			line-height: rem(28);
		}
	}

	.banner-users {
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		.detect_deviece_mobile & {
			flex-direction: column;
			gap: rem(16);
			align-items: flex-start;
		}
	}

	.user-avatars {
		flex-shrink: 0;
		width: rem(130);
		height: rem(40);
		position: relative;
	}

	.avatar-wrapper {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		position: absolute;
		left: 0px;
		top: 0px;
	}

	.avatar {
		border-radius: 50%;
		border-style: solid;
		border-color: #ffffff;
		border-width: rem(2);
		flex-shrink: 0;
		width: rem(40);
		height: rem(40);
		position: relative;
		box-shadow: inset rem(4) rem(4) rem(8) 0px rgba(0, 0, 0, 0.24);
		background-color: #cccccc; /* 使用灰色背景代替头像 */

		&:not(:first-child) {
			margin: 0 0 0 rem(-10);
		}
	}

	.user-count {
		color: #1a4048;
		text-align: left;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 400;
		position: relative;
	}

	.banner-image {
		flex-shrink: 0;
		width: rem(656);
		height: rem(520);
		position: relative;
		overflow: visible;

		.detect_deviece_mobile & {
			width: 100%;
			height: auto;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}
}
</style> 